const str = `{HEADER}저작권 정책
{BODY_TITLE}
비디오몬스터의 서비스를 이용해 제작한 완성물을 재판매하는 것은 금지되어 있습니다. "동의하고 가입완료"를 누르시면 이에 동의 하시는 것으로 간주 됩니다.
비디오몬스터가 좋은 서비스를 최저가로 유지할 수 있도록 도와주세요. 건전한 콘텐츠 문화, 함께 만들어가요!
`

export default str